import React from 'react';
import styled from 'styled-components';

import useCssTransforms3dSupported from '@hooks/useCssTransforms3dSupported';
import { getInputColors } from './helper/colors';

const StyledLabel = styled.label`
  color: ${props => props.theme.colors.textHint};
  pointer-events: none;
  font-size: 16px;
  line-height: 1.38;
  position: absolute;
  top:  ${({ cssTransforms3dSupported }) =>
    cssTransforms3dSupported ? '12px' : '0px'};
  ${({ showPlaceholder, cssTransforms3dSupported }) =>
    showPlaceholder &&
    cssTransforms3dSupported &&
    `transform: translate3d(0px, -17px, 0px) scale3d(0.75, 0.75, 1);
     transform-origin: left;`}
  ${({ showPlaceholder, cssTransforms3dSupported }) =>
    showPlaceholder &&
    !cssTransforms3dSupported &&
    `top: -2px;
    font-size: 12px;
    line-height: 1.33;`}      
  ${props => props.showPlaceholder && getInputColors(props)};
  transition: 0.2s ease all;
  z-index: 1;
`;

function Label(props) {
  const cssTransforms3dSupported = useCssTransforms3dSupported();
  return (
    <StyledLabel
      {...props}
      cssTransforms3dSupported={cssTransforms3dSupported}
    />
  );
}

export default Label;
